module.exports = __webpack_public_path__ + "img/Wp_2063.cda5ffdb.png";